module.exports = __webpack_public_path__ + "img/USDTT.48a0e22c.png";